import React, {useState} from "react";
import {Link} from "react-router-dom";
import "./Shortcut.scss";

export default function Shortcut(props) {
  const [buttons, setButtons] = useState([
    {
      title: "فاکتور فروش",
      class: "shortcut-btn",
      link: "/sellFactor",
    },
    {
      title: "فاکتور خرید",
      class: "shortcut-btn",
      link: "/Operation/1-m",
    },
    {
      title: "انبار کالا",
      class: "shortcut-btn",
      link: "/addMultiProduct",
    },
    {
      title: "بررسی صندوق",
      class: "shortcut-btn",
      link: "List/873-s",
    },
    {
      title: "بستن صندوق",
      class: "shortcut-btn",
      link: "List/874-s",
    },
    {
      title: "  انبار گردانی",
      class: "shortcut-btn",
      link: "List/872-s",
    },
    {
      title: " دریافت چک",
      class: "shortcut-btn",
      link: "List/69-s",
    },
    {
      title: "  موجودی اولیه",
      class: "shortcut-btn",
      link: "List/870-s",
    },
    {
      title: " دریافت حواله",
      class: "shortcut-btn",
      link: "List/106-s",
    },
    {
      title: " دریافت وجه نقد",
      class: "shortcut-btn",
      link: "List/133-s",
    },
  ]);
 try {
   return (
     <div className="shortcut-container">
       {props.shortcuts.map((button, index) => {
         return (
           <Link key={index} to={button.url} className="shortcut-btn">
             <img src={button.icon} alt=""/>
             {button.title}
           </Link>
         );
       })}
       {/*این نباید توی پروژه ی روانحساب بیاد*/}
       {/*{props.ShowAdminReport === true ? (*/}
       {/*  <Link to={"/adminReport"} className={"btn btn-info"}>*/}
       {/*    گزارش مدیریتی*/}
       {/*  </Link>*/}
       {/*) : (*/}
       {/*  <></>*/}
       {/*)}*/}

       {props.showPhaseOptions === true ? (
         <Link
           to={"/phaseOptions"}
           className={"btn btn-light border border-black"}
         >
           مدیریت فاز
         </Link>
       ) : (
         <></>
       )}
     </div>
   );
 }catch (error){
   return <>{error.toString()}</>
 }
}
